import { getBlockSlugPathQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { segmentForBlockType } from '#/features/community-hub/utils/content-urls';

/**
 * Legacy pdf-viewer URL. Redirects to `/programs/{program}/{module}/{lesson}/pdf/{item}`.
 * Blocks in a single-lesson space have no module slug — those stay on the legacy route.
 */
export const Route = createFileRoute(
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/pdf/$contentId',
)({
  beforeLoad: async ({ params }) => {
    const path = await queryClient.ensureQueryData(getBlockSlugPathQueryOptions(params.contentId));
    if (!path.blockType) {
      return;
    }
    const segment = segmentForBlockType(path.blockType);
    if (!segment) {
      return;
    }
    const to = path.moduleSlug
      ? `/programs/${path.programSlug}/${path.moduleSlug}/${path.lessonSlug}/${segment}/${path.itemSlug}`
      : `/programs/${path.programSlug}/${segment}/${path.itemSlug}`;
    throw redirect({ to, replace: true });
  },
});
